<template>
  <div class="row">
    <div class="col-12">
      <div class="column">
        <div class="col-auto">
          <div class="row">
            <div class="col">
              <Treeselect
                searchable
                search-nested
                open-on-click
                open-on-focus
                clear-on-select
                close-on-select
                disable-branch-nodes

                open-direction="bottom"
                :multiple="false"
                :clearable="false"

                v-model="optionValue"
                :disabled="disabled"
                :max-height="200"
                placeholder="Selecione uma opção"
                :options="searchOptions"
                no-results-text="Nada encontrado"
                search-prompt-text="Buscar"
                :match-keys="['search', 'label']"
              />
            </div>
          </div>
        </div>

        <div
          v-if="children"
          class="col-auto q-py-xs"
        >
          <FieldSubTree
            v-model="values"
            :options="children"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  name: 'FieldSubTree',

  components: {
    Treeselect
  },

  props: {
    value: {},
    options: {},
    disabled: {}
  },

  data () {
    const values = Array.isArray(this.value) ? [...this.value] : []
    const option = this.options ? this.options.find(({ id }) => values.includes(id)) : ''
    const children = option && option.children && option.children.length ? option.children : null
    const optionValue = option?.id
    return { values, children, optionValue }
  },

  computed: {
    searchOptions () {
      if (!this.options) return
      return this.options.map((option) => {
        const search = clearStr(option.label)
        return { ...option, search, children: undefined }
      })
    }
  },

  watch: {
    optionValue (optionValue, oldValue) {
      const values = Array.isArray(this.values) ? [...this.values] : []

      if (optionValue) {
        if (!values.includes(optionValue)) values.push(optionValue)
      }

      if (oldValue && values.includes(oldValue)) {
        values.splice(values.indexOf(oldValue), 1)
        const oldOption = this.options.find(({ id }) => id === oldValue)
        reduceChildren(oldOption?.children).forEach((oldChildId) => {
          if (values.includes(oldChildId)) values.splice(values.indexOf(oldChildId), 1)
        })
      }

      const option = this.options.find(({ id }) => id === optionValue)
      const children = option && option.children && option.children.length ? option.children : null

      if (!isEqual(values, this.values)) this.values = values
      if (!isEqual(children, this.children)) this.children = children
    },

    values (values) {
      if (isEqual(values, this.value)) return
      this.$emit('input', values)
    },

    value (value) {
      const values = Array.isArray(value) ? [...value] : []
      if (isEqual(values, this.values)) return
      this.values = values
    }
  }
}

const reduceChildren = (children) => {
  if (!children) return []
  if (!children.length) return []

  return children.reduce((acc, item) => {
    acc.push(item.id)
    const children = reduceChildren(item.children)
    return acc.concat(children)
  }, [])
}

const isEqual = (source, target) => JSON.stringify(source) === JSON.stringify(target)
const clearStr = (str) => String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim()
</script>
